"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _ModuleCompatibilityTagTypes = _interopRequireDefault(require("marketplace-lib/constants/ModuleCompatibilityTagTypes"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var _default = _react.default.createClass({
  displayName: "MultiselectCheckboxFilter",
  mixins: [_ComponentWithPartials.default, _reactAddonsPureRenderMixin.default],
  propTypes: {
    disableOptions: _react.PropTypes.bool.isRequired,
    filterName: _react.PropTypes.string.isRequired,
    filtersCurrentlyAppliedInComponent: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    showSelectAll: _react.PropTypes.bool.isRequired,
    trackMultiselectSelection: _react.PropTypes.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disableOptions: false,
      showSelectAll: false
    };
  },
  getFilterOptions: function getFilterOptions() {
    var filterName = this.props.filterName;
    return (0, _utils.getMultiselectCheckboxFilterOptions)(filterName);
  },
  onFilterOptionChange: function onFilterOptionChange(filterOption, event) {
    var _this$props = this.props,
        filterName = _this$props.filterName,
        currentFilters = _this$props.filtersCurrentlyAppliedInComponent,
        onGoodFilterChange = _this$props.onGoodFilterChange,
        trackMultiselectSelection = _this$props.trackMultiselectSelection;
    var isChecked = event.target.checked;

    if (isChecked) {
      trackMultiselectSelection(filterName, filterOption);
    }

    if (filterName === _GoodFiltersAndPage.default.MODULE_COMPATIBILITY) {
      var filterOptions = _immutable.default.List(this.getFilterOptions());

      var includesAllCompatibility = currentFilters.includes(_ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY);

      var updatedFilters = _immutable.default.List([]);

      if (isChecked) {
        if (includesAllCompatibility) {
          updatedFilters = currentFilters.clear().push(filterOption);
        } else {
          updatedFilters = currentFilters.push(filterOption);
        }
      } else {
        if (includesAllCompatibility) {
          updatedFilters = filterOptions.filter(function (opt) {
            return opt !== filterOption;
          });
        } else {
          updatedFilters = currentFilters.filter(function (opt) {
            return opt !== filterOption;
          });
        }
      }

      if (filterOptions.every(function (opt) {
        return updatedFilters.includes(opt);
      })) {
        updatedFilters = updatedFilters.clear().push(_ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY);
      }

      onGoodFilterChange((0, _defineProperty2.default)({}, filterName, updatedFilters));
      return;
    }

    if (isChecked) {
      onGoodFilterChange((0, _defineProperty2.default)({}, filterName, currentFilters.push(filterOption)));
      return;
    }

    onGoodFilterChange((0, _utils.getMultiselectFilterObjAfterRemove)(filterName, currentFilters, filterOption));
  },
  onSelectAll: function onSelectAll(event) {
    var _this$props2 = this.props,
        filterName = _this$props2.filterName,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        trackMultiselectSelection = _this$props2.trackMultiselectSelection;
    var isChecked = event.target.checked;
    var filterOptions = filterName === _GoodFiltersAndPage.default.MODULE_COMPATIBILITY ? [_ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY] : this.getFilterOptions();
    onGoodFilterChange((0, _defineProperty2.default)({}, filterName, event.target.checked ? filterOptions : []));

    if (isChecked) {
      trackMultiselectSelection(filterName, 'ALL');
    }
  },
  renderCheckboxes: function renderCheckboxes() {
    var _this = this;

    var _this$props3 = this.props,
        disableOptions = _this$props3.disableOptions,
        filterName = _this$props3.filterName,
        currentFilters = _this$props3.filtersCurrentlyAppliedInComponent;
    var filterOptions = this.getFilterOptions();
    var isModuleCompatibility = filterName === _GoodFiltersAndPage.default.MODULE_COMPATIBILITY;
    var includesAllCompatibility = currentFilters.includes(_ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY);
    return filterOptions.map(function (filterOption, index) {
      var checked = currentFilters.includes(filterOption) || isModuleCompatibility && includesAllCompatibility;
      return _react.default.createElement(_UICheckbox.default, {
        checked: checked,
        className: "integrate-" + filterOption,
        disabled: disableOptions,
        innerPadding: "none",
        key: index,
        onChange: _this.partial(_this.onFilterOptionChange, filterOption),
        size: "small"
      }, (0, _langUtils.getMultiselectFilterOptionOrTitleText)(filterName, filterOption));
    });
  },
  renderSelectAllCheckbox: function renderSelectAllCheckbox() {
    var _this$props4 = this.props,
        disableOptions = _this$props4.disableOptions,
        filterName = _this$props4.filterName,
        currentFilters = _this$props4.filtersCurrentlyAppliedInComponent,
        showSelectAll = _this$props4.showSelectAll;

    if (!showSelectAll) {
      return null;
    }

    var filterOptions = this.getFilterOptions();
    var allSelected = false;
    var someSelected = false;

    if (filterName === _GoodFiltersAndPage.default.MODULE_COMPATIBILITY) {
      allSelected = currentFilters.includes(_ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY);
    } else {
      allSelected = filterOptions.every(function (val) {
        return currentFilters.includes(val);
      });
      someSelected = !allSelected && currentFilters.size > 0;
    }

    return _react.default.createElement(_UICheckbox.default, {
      checked: allSelected,
      disabled: disableOptions,
      indeterminate: someSelected,
      innerPadding: "none",
      onChange: this.onSelectAll,
      size: "small"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "MarketplaceUI.directory.sidebar.multiselectCheckboxFilter.all"
    }));
  },
  render: function render() {
    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "is--heading-7 m-bottom-2"
    }, (0, _langUtils.getMultiselectFilterOptionOrTitleText)(this.props.filterName, 'title')), _react.default.createElement(_UIList.default, {
      childClassName: "m-bottom-2"
    }, this.renderSelectAllCheckbox(), this.renderCheckboxes()));
  }
});

exports.default = _default;
module.exports = exports.default;